module.exports = __webpack_public_path__ + "static/media/leona.6f93df7d.jpg";